import React from "react";
import { Skeleton } from "primereact/skeleton";

function skeletonWidth(colIndex: number, colCount: number): string {
  if (colIndex === 0) return "55%";
  if (colIndex === 1) return "88%";
  if (colIndex === colCount - 1) return "68%";
  return "72%";
}

interface OperationalDataTableSkeletonProps {
  columns: string[];
  rows?: number;
}

export default function OperationalDataTableSkeleton({
  columns,
  rows = 8,
}: OperationalDataTableSkeletonProps) {
  const colCount = columns.length;

  return (
    <div className="overflow-x-auto" role="status" aria-live="polite">
      <span className="sr-only">Loading table data</span>
      <table className="w-full min-w-full border-collapse text-left text-sm">
        <thead>
          <tr className="border-b border-[#E2E8F0] bg-[#F0F9FF]">
            {columns.map((header) => (
              <th
                key={header}
                className="px-4 py-3 text-[0.72rem] font-bold uppercase tracking-wide text-[#64748B] sm:px-5"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-[#E2E8F0]/80 bg-white">
          {Array.from({ length: rows }, (_, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((header, colIndex) => (
                <td
                  key={`${header}-${colIndex}`}
                  className="px-4 py-3 align-middle sm:px-5"
                >
                  <Skeleton
                    height="0.875rem"
                    borderRadius="6px"
                    width={skeletonWidth(colIndex, colCount)}
                    className="block max-w-full"
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
